import styled from 'styled-components';

// Images
import YoutubeLogoSource from '../../../images/youtube-footer.svg';

const YoutubeLogo = styled(YoutubeLogoSource)`
  max-width: 100%;
  height: auto;

  path {
    fill: var(--colors-mischka);
    fill-opacity: 0.7;
  }
`;

export default YoutubeLogo;
